import { Component, computed, OnDestroy, OnInit } from "@angular/core";
import {  FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { OrderWizardService } from "../../_service/order-wizard.service";
import { CorpDropdownComponent, CorpInputComponent, CorpInputDecimalComponent, CorpLoadingComponent, CorpPopMenuComponent } from "@corporate-tailwind/component";
import { CorpModalComponent} from "@corporate-tailwind/modal";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { CurrencyDirection } from "../../../model/order-currency-direction.model";
import { OrderPurchaseSummaryComponent } from "../summary/order-purchase-summary.component";
import { CurrencyPurchaseDto } from "src/app/features/pages/front-pages/common/fp-order-panel/fp-order-purchase/model/currency-purchase.model";

@Component({
    selector: 'order-wizard-purchase',
    imports: [CommonModule, ReactiveFormsModule, OrderPurchaseSummaryComponent, CorpLoadingComponent, CorpModalComponent, CorpDropdownComponent, CorpInputDecimalComponent, TranslateModule],
    templateUrl: './order-wizard-purchase.component.html',
    animations: [ ]
})
export class OrderWizardPurchaseComponent implements OnInit, OnDestroy {
    form: FormGroup | null = null;
    isActive: boolean = false;
    selectedIdToDelete: number | null = null;
    currencyDirection = CurrencyDirection;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
  
    }

    toggleDirection(id: number) {
        const key = this._orderWizardService.modelNames.step01.fields.currencyPurchaseList.fields.direction.key;
        const oldValue= this._orderWizardService.getArrayValue(x=>x.step01?.currencyPurchaseList, id);
        const direction = oldValue.get(key).value == CurrencyDirection.SourceToTarget
            ? CurrencyDirection.TargetToSource
            : CurrencyDirection.SourceToTarget;
        
        this._orderWizardService.setArrayValue(x=>x.step01?.currencyPurchaseList, id,key, direction);
    }

    addCurrencyPurchase(): void {
        this._orderWizardService.addCurrencyPurchase();
    }

    openDeleteModal(id: number): void {
        this.selectedIdToDelete = id;
        this.isActive = true;
    }

    confirmDelete(): void {
        if (this.selectedIdToDelete === null) return;

        this._orderWizardService.deleteItem(this.selectedIdToDelete);
        this.isActive = false;
        this.selectedIdToDelete = null;
    }

}